/* eslint-disable react/display-name */
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';

const CustomRecordingFilter = forwardRef((props, ref) => {
  const { defaultOption = 'All', filterChangedCallback, values } = props;
  const [filterState, setFilterState] = useState(defaultOption);

  useImperativeHandle(ref, () => ({
    isFilterActive: () => filterState,
    doesFilterPass: (params) => {
      const videoItemKey =
        params.data.videoItemKeyV2?.itemKey ?? params.data.videoItemKey ?? '';
      if (filterState === 'Uploaded') {
        return (
          videoItemKey !== undefined &&
          videoItemKey !== null &&
          videoItemKey !== ''
        );
      } else if (filterState === 'Not Uploaded') {
        return (
          videoItemKey === undefined ||
          videoItemKey === null ||
          videoItemKey === ''
        );
      } else {
        return true;
      }
    },
    getModel: () => (filterState === '' ? undefined : { state: filterState }),
    setModel: (model) => setFilterState(model?.state || ''),
    getModelAsString: () => filterState,
    onNewRowsLoaded: () => console.log('new rows were loaded'),
    onAnyFilterChanged: () => console.log('another filter was changed'),
    afterGuiAttached: () => console.log('focus something???'),
  }));

  useEffect(
    () => filterChangedCallback(),
    [filterState, filterChangedCallback]
  );

  const handleFilterChange = (value) => setFilterState(value);

  return (
    <div className='overflow-y-auto max-h-60'>
      {values?.length > 0 ? (
        values.map((value) => (
          <div
            key={value}
            className={`filter-entry my-1 px-2 font-medium ${
              value === filterState ? 'text-blue-c3' : ''
            }`}
          >
            <label className='flex items-center gap-2'>
              <input
                type='radio'
                onChange={() => handleFilterChange(value)}
                checked={filterState === value}
              />
              {value}
            </label>
          </div>
        ))
      ) : (
        <p className='px-2 font-medium'>No option available</p>
      )}
    </div>
  );
});

export default CustomRecordingFilter;
